document.addEventListener('DOMContentLoaded', () => {
  const docBody = document.querySelector('body');
  const modal = document.getElementById('new-icon-block-popup');
  const modalBody = document.getElementById('new-icon-block-popup-body');
  const closeBtn = document.querySelector('.new-icon-block-popup-close');
  const pagesBtns = document.querySelectorAll('.new-icon-block-link');
  const contenido = document.querySelector('.new-icon-block-popup-content');

  // RD: páginas que se muestran completas (con sus secciones) dentro del modal
  const paginasCompletas = ['beneficios'];
  // RD: en celular, la landing dentro del modal se muestra como listado vertical
  const estilosModalMobile = `<style>
  #new-icon-block-popup-body{overflow-x:hidden!important;box-sizing:border-box}
  #new-icon-block-popup-body *{max-width:100%;box-sizing:border-box}
@media (max-width:767px){
  #new-icon-block-popup-body{padding-left:16px!important;padding-right:16px!important;padding-bottom:100px!important}
  #new-icon-block-popup-body [class*="wrapper"]{width:auto!important;max-width:100%!important;margin-left:0!important;margin-right:0!important;padding-left:0!important;padding-right:0!important}
  #new-icon-block-popup-body .section-padding{padding-top:16px!important;padding-bottom:8px!important}
  #new-icon-block-popup-body .mosaic__grid{display:flex!important;flex-direction:column!important;flex-wrap:nowrap!important;overflow:visible!important;margin:0!important;padding:0!important;gap:14px}
  #new-icon-block-popup-body .mosaic__grid::after{content:none!important}
  #new-icon-block-popup-body .mosaic__item{width:100%!important;flex:0 0 auto!important;margin:0!important;padding:0!important;align-self:stretch!important}
  #new-icon-block-popup-body .mosaic__item__inner{width:100%!important;flex-direction:row!important;align-items:center!important;justify-content:flex-start!important;gap:12px}
  #new-icon-block-popup-body .mosaic__item__image{flex:0 0 110px!important;width:110px!important;height:75px!important;padding-top:0!important}
  #new-icon-block-popup-body .mosaic__item__content{padding:0!important;flex:1}
  #new-icon-block-popup-body .mosaic__item__subheading{margin-bottom:2px!important}
  #new-icon-block-popup-body .mosaic__item__heading{font-size:17px!important;margin-bottom:2px!important}
  #new-icon-block-popup-body .mosaic__item__text{font-size:13px!important;margin-bottom:6px!important}
  #new-icon-block-popup-body .mosaic__item__buttons{justify-content:flex-start!important}
  #new-icon-block-popup-body .mosaic__item__btn{padding:6px 14px!important;min-height:0!important}
}
@media (min-width:768px){
  #new-icon-block-popup-body{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr));gap:24px 18px;align-items:start;padding:0 32px 32px!important}
  #new-icon-block-popup-body .shopify-section:not(.shopify-section--mosaic){grid-column:1/-1}
  #new-icon-block-popup-body .shopify-section--mosaic,
  #new-icon-block-popup-body section.mosaic,
  #new-icon-block-popup-body mosaic-component,
  #new-icon-block-popup-body .mosaic__wrapper,
  #new-icon-block-popup-body .mosaic__grid{display:contents!important}
  #new-icon-block-popup-body .shopify-section--mosaic::before,
  #new-icon-block-popup-body .shopify-section--mosaic::after,
  #new-icon-block-popup-body section.mosaic::before,
  #new-icon-block-popup-body section.mosaic::after,
  #new-icon-block-popup-body mosaic-component::before,
  #new-icon-block-popup-body mosaic-component::after,
  #new-icon-block-popup-body .mosaic__wrapper::before,
  #new-icon-block-popup-body .mosaic__wrapper::after,
  #new-icon-block-popup-body .mosaic__grid::before,
  #new-icon-block-popup-body .mosaic__grid::after{content:none!important;display:none!important}
  #new-icon-block-popup-body .section-padding{padding-top:20px!important;padding-bottom:4px!important}
  #new-icon-block-popup-body .mosaic__item{width:auto!important;margin:0!important;padding:0!important}
  #new-icon-block-popup-body .mosaic__item__inner{display:flex!important;flex-direction:column!important}
  #new-icon-block-popup-body .mosaic__item__image{position:relative!important;width:100%!important;height:110px!important;padding-top:0!important}
  #new-icon-block-popup-body .mosaic__item__content{padding:10px 0 0!important}
  #new-icon-block-popup-body .mosaic__item__subheading{font-size:10px!important;margin-bottom:2px!important}
  #new-icon-block-popup-body .mosaic__item__heading{font-size:15px!important;margin-bottom:2px!important}
  #new-icon-block-popup-body .mosaic__item__text{font-size:12px!important;margin-bottom:8px!important}
  #new-icon-block-popup-body .mosaic__item__buttons{justify-content:flex-start!important}
  #new-icon-block-popup-body .mosaic__item__btn{padding:5px 12px!important;min-height:0!important;font-size:12px!important}
}
@media (min-width:1200px){
  #new-icon-block-popup-body{grid-template-columns:repeat(6,minmax(0,1fr))}
}
</style>`;

  const closePopup = () => {
    docBody.style.overflow = '';
    if (modal) modal.style.display = 'none';
    if (modalBody) modalBody.innerHTML = '';
  };

  const quitarAnimaciones = (contenedor) => {
    contenedor.querySelectorAll('*').forEach(element => {
      [...element.attributes].forEach(attr => {
        if (attr.name.startsWith('data-aos')) element.removeAttribute(attr.name);
      });
    });
  };

  pagesBtns.forEach((btn) => {
    btn.addEventListener('click', async function (e) {
      docBody.style.overflow = 'hidden';
      const link = btn.getAttribute('data-link');
      if (!link) return;

      const pageHandle = btn.getAttribute('data-page-handle');

      // Si cargan una imagen
      if (pageHandle && pageHandle.includes('cdn.shopify')) {
        if (contenido) contenido.classList.add('rd-modal-compacto');
        modal.style.display = 'block';
        modalBody.innerHTML = `<img src="${pageHandle}" alt="web image" style="width: 100%; height: auto;">`;
        return;
      }

      if (!pageHandle || !modal || !modalBody) return;

      // RD: modo compacto para páginas simples; la de beneficios mantiene el tamaño grande
      const esCompleta = paginasCompletas.includes(pageHandle);
      if (contenido) contenido.classList.toggle('rd-modal-compacto', !esCompleta);
      modal.style.display = 'block';
      modalBody.innerHTML = '<p style="padding: 20px; text-align: center;">Cargando...</p>';

      const url = esCompleta ? `/pages/${pageHandle}` : `/pages/${pageHandle}?view=content-only`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok.');
        const html = await response.text();
        const divElement = document.createElement('div');
        divElement.innerHTML = html;

        if (esCompleta) {
          // RD: landing completa (todas las secciones de la página)
          const main = divElement.querySelector('main');
          quitarAnimaciones(main);
          main.querySelectorAll('.skeleton-loading').forEach(el => el.classList.remove('skeleton-loading'));
          modalBody.innerHTML = main.innerHTML;
          modalBody.querySelectorAll('link[rel="preload"][as="style"]').forEach(l => { l.rel = 'stylesheet'; });
          modalBody.insertAdjacentHTML('afterbegin', estilosModalMobile);
          modalBody.querySelectorAll('mosaic-component').forEach(el => { el.style.display = 'block'; });
        } else {
          const main = divElement.querySelector('main section .wrapper');
          quitarAnimaciones(main);
          modalBody.innerHTML = main.innerHTML;
        }
      } catch (error) {
        docBody.style.overflow = '';
        console.error('Popup Script Error:', error);
        modalBody.innerHTML = '<p style="padding: 20px; color:red; text-align:center;">An error occurred while loading the content.</p>';
      }
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', () => closePopup());
  if (modal) modal.addEventListener('click', e => { if (e.target === modal) closePopup(); });
});